import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './cipideatable.cssmodule.scss';
import TableFilterHeader from '../Shared/TableFilterHeader';
import { Link } from 'react-router';
import { injectIntl, intlShape, FormattedRelative } from 'react-intl';
import Pager from '../Shared/Pager';
import classNames from 'classnames';
import { FormattedDate } from 'react-intl';
import IdeaStateLabel from '../Shared/IdeaStateLabel';
import UserSelect from '../Shared/UserSelect';
import { Button, Glyphicon, MenuItem, DropdownButton } from 'react-bootstrap';
import { convertCipIdeaStateName, CIP_TYPE } from '../../constants';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import Select from 'react-select';


class CipIdeaTable extends React.Component {

  constructor(props) {
    super(props);
    const { intl } = props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };

    this.state = {
      filterEnabled: true,
      filter: {
        State: -1,
        CipGroupId: -1,
        UserId: -1
      },
      dateRanges: {
        [t('All')]: [moment().add(-100, 'years'), moment().add(1, 'years')],
        [t('Last 7 Days')]: [moment().subtract(6, 'days'), moment()],
        [t('Last 30 Days')]: [moment().subtract(29, 'days'), moment()],
        [t('This Month')]: [moment().startOf('month'), moment().endOf('month')],
        [t('Last Month')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        [t('This Year')]: [moment().startOf('year'), moment()]
      },
      dateRange: {
        CreatedEnd: moment().add(1, 'years'),
        CreatedStart: moment().add(-100, 'years')
      }
    };
  }

  handleFilterChange(propertyName, event) {
    var filter;
    if (typeof event === 'object') {
      filter = { ...this.state.filter, [propertyName]: event.target.value };

    }
    else {
      filter = { ...this.state.filter, [propertyName]: event };
    }
    //fire filter changed
    const { filterChanged } = this.props;
    if (filterChanged) {
      filterChanged(filter);
    }
    this.setState({
      filter: filter
    });
  }

  onSelectUserFilter(propertyName, usr) {
    var filter = { ...this.state.filter, [propertyName]: usr ? usr.Id : 0 };
    const { filterChanged } = this.props;
    if (filterChanged) {
      filterChanged(filter);
    }
    this.setState({
      filter: filter
    });
  }

  handleCipGroupSelect(evt) {
    var filter = { ...this.state.filter, 'CipGroupId': evt ? evt.Id : -1 };
    this.setState({
      filter: filter
    });
    const { filterChanged } = this.props;
    if (filterChanged) {
      filterChanged(filter);
    }
  };

  handleCreatedRangeChange(event, picker) {
    var filter = {
      ...this.state.filter,
      CreatedStart: picker.startDate.format('YYYY-MM-DD'),
      CreatedEnd: picker.endDate.format('YYYY-MM-DD'),
    };
    const { filterChanged } = this.props;
    if (filterChanged) {
      filterChanged(filter);
    }
    this.setState({
      filter: filter,
      dateRange: {
        CreatedStart: picker.startDate,
        CreatedEnd: picker.endDate,
      }
    });
  }

  handleNextPage() {
    const { loadNextPage } = this.props;
    loadNextPage(this.state.filter);
  }

  handlePrevPage() {
    const { loadPrevPage } = this.props;
    loadPrevPage(this.state.filter);
  }

  toggleFilter(event) {
    this.setState({
      filterEnabled: !this.state.filterEnabled
    });
  }
  render() {
    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };
    const { cipIdeaPage } = this.props;
    const { cipGroups } = this.props;

    return (
      <div className="brand-panel panel panel-default filterable cipideatable-component" styleName="cipideatable-component">
        <div className="panel-heading">
          <h3 className="panel-title">
            {t('CIP_FULL')}
            {
              cipIdeaPage.Loading && (<span className="fa fa-refresh fa-spin" style={{ marginLeft: '10px' }}></span>)
            }
          </h3>
          <div className="pull-right">
            <button className="btn btn-default btn-xs btn-filter" onClick={this.toggleFilter.bind(this)}><span className="glyphicon glyphicon-filter"></span>
              {t('Filter')}
            </button>
          </div>
        </div>
        <div className="panel-body table-responsive" styleName="table-container">
          <Pager pageIndex={cipIdeaPage.PageIndex} totalPageCount={cipIdeaPage.TotalPageCount} loading={cipIdeaPage.Loading} nextClick={this.handleNextPage.bind(this)}
            prevClick={this.handlePrevPage.bind(this)} />

          <table className="table">
            <thead>
              <tr>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Id')}>
                  <input onChange={this.handleFilterChange.bind(this, 'CipIdeaId')} type="text" className="form-control input-sm" placeholder={t('Id')} />
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Created')}>
                  <DateRangePicker autoUpdateInput={false} startDate={this.state.dateRange.CreatedStart} endDate={this.state.dateRange.CreatedEnd} ranges={this.state.dateRanges} onApply={this.handleCreatedRangeChange.bind(this)}>
                    <Button className="selected-date-range-btn" style={{ width: '100%' }} bsSize="small">
                      <Glyphicon glyph="calendar" />
                    </Button>
                  </DateRangePicker>
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Title')}>
                  <input onChange={this.handleFilterChange.bind(this, 'Title')} type="text" className="form-control input-sm" placeholder={t('Title')} />
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('CIP-Group')} style={{ minWidth: '120px' }}>
                  <Select className="compact" placeholder={t('Select') + ' ...'}
                    value={this.state.filter.CipGroupId}
                    options={cipGroups.Groups} onChange={this.handleCipGroupSelect.bind(this)}
                  />
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Status')} style={{ width: '30px' }}>
                  <DropdownButton value={this.state.filter.State} onSelect={this.handleFilterChange.bind(this, 'State')} title={t(convertCipIdeaStateName(this.state.filter.State))} id="dd-filter-state" className="btn-brand btn btn-default btn-sm">
                    <MenuItem eventKey="-1">{t(convertCipIdeaStateName(-1))}</MenuItem>
                    <MenuItem eventKey="0">{t(convertCipIdeaStateName(0))}</MenuItem>
                    <MenuItem eventKey="1">{t(convertCipIdeaStateName(1))}</MenuItem>
                    <MenuItem eventKey="2">{t(convertCipIdeaStateName(2))}</MenuItem>
                    <MenuItem eventKey="3">{t(convertCipIdeaStateName(3))}</MenuItem>
                  </DropdownButton>
                </TableFilterHeader>
                {
                  !this.state.filterEnabled && (<th>{t('Idea originator')}</th>)
                }
                {
                  !this.state.filterEnabled && (<th>{t('Responsible person')}</th>)
                }
                {
                  this.state.filterEnabled && (
                    <th colSpan="2" style={{ minWidth: '150px' }}>
                      <UserSelect compact={true} userId={this.state.filter.UserId} onSelectUser={this.onSelectUserFilter.bind(this, "UserId")} />
                    </th>
                  )
                }
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Modified')}>
                  <p className="form-control-static"> {t('Modified')}</p>
                </TableFilterHeader>

              </tr>
            </thead>
            <tbody>
              {cipIdeaPage.TotalCount == 0 && <tr>
                <td colSpan="8">
                  <div className="alert alert-warning">
                    <strong>Oops!</strong>&nbsp;{t('NO_DATA')}
                  </div>
                </td>
              </tr>
              }

              {
                cipIdeaPage.Data.map((i, idx) =>
                (<tr key={i.Id} className={classNames({ 'warning': i.State == 1, 'success': i.State == 2, 'danger': i.State == 3 })}>
                  <td><Link to={"/process-cip/" + i.Id}>{i.Id}</Link></td>
                  <td><FormattedDate value={i.Created} /></td>
                  <td><Link to={"/process-cip/" + i.Id}>{i.Title}</Link></td>
                  <td>{i.CipGroup ? i.CipGroup.Title : ''}</td>
                  <td><IdeaStateLabel state={i.State} type={CIP_TYPE} /></td>
                  <td>{i.Author.DisplayName}</td>
                  <td>{i.CipGroup && i.CipGroup.CipGroupManager ? i.CipGroup.CipGroupManager.DisplayName : ''}</td>
                  <td><FormattedDate value={i.LastModified} /></td>
                </tr>)
                )
              }

            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

CipIdeaTable.displayName = 'CipIdeaTable';
CipIdeaTable.propTypes = {};
CipIdeaTable.defaultProps = {};

export default injectIntl(cssmodules(CipIdeaTable, styles));



// WEBPACK FOOTER //
// ./components/BrowseIdeas/CipIdeaTable.js